import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { AnswerFormActivity } from 'modules/forms/activities/answerForm'
import { FormResponsesActivity } from 'modules/forms/activities/formResponses'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    answerForm: {
      component: AnswerFormActivity,
    },
    formResponses: {
      component: FormResponsesActivity,
    },
  },
} as const satisfies DomainManifest
